import "./services.css";

import React from "react";

import { SERVICES } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { PageHero, Split, SplitItem } from "../general/PageSections";

const Services = () => {
  return (
    <React.Fragment>
      <PageMeta
        title={"Services"}
        description={SERVICES.OUTRO}
      />
      <PageHero src={"/images/services/poolside-breakfast.webp"} />

      <section className={"services-facilities"}>
        <div className={"container"}>
          <h1 className={"heading is-display"}>{SERVICES.TITLE}</h1>
          <div className={"services-facilities-grid"}>
            {SERVICES.FACILITIES.map((column, i) => (
              <ul key={i}>
                {column.map((item) => (
                  <li key={item}>✓ {item}</li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </section>

      {SERVICES.SPLITS.map((split) => (
        <Split
          key={split.items[0].title}
          image={split.image}
          isImageFirst={split.isImageFirst}
        >
          {split.items.map((item) => (
            <SplitItem
              key={item.title}
              {...item}
              isDisplayFont
            />
          ))}
        </Split>
      ))}

      <section className={"statement"}>
        <div className={"container"}>
          <p className={"statement-text is-display"}>{SERVICES.OUTRO}</p>
        </div>
      </section>

    </React.Fragment>
  );
};

export default Services;
